import { useEffect } from "react";

import { Navbar } from "./components/Navbar";
import { Home } from "./components/Home";
import { About } from "./components/About";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contacts } from "./components/Contacts";

import { WOW } from "wowjs";
import "animate.css";
import "./App.css";

const App = () => {
  const ScrollingFunction = () => {
    if (
      document.body.scrollTop > 200 ||
      document.documentElement.scrollTop > 200
    ) {
      document.getElementsByClassName("navbar-nav")[0].style.fontSize = "14px";
      document.getElementsByClassName("logoFont")[0].style.fontSize =
        "1.3rem";
      document.getElementsByClassName("logoFont")[0].style.transition =
        "all 0.3s cubic-bezier(0.8,1,1,0.8)";
      document.getElementById("navbar").style.background =
        "#1d1c23";
      document.getElementById("navbar").style.boxShadow =
        "0 4px 8px 0 #1d1c2382";
      document.querySelectorAll(".nav-item").forEach(function (elem) {
        elem.style.padding = "0.2rem";
        elem.style.transition = "all 0.3s cubic-bezier(0.8,1,1,0.8)";
      });
    } else {
      document.getElementsByClassName("navbar-nav")[0].style.fontSize = "16px";
      document.getElementsByClassName("logoFont")[0].style.fontSize =
        "1.6rem";
      document.getElementsByClassName("logoFont")[0].style.transition =
        "all 0.3s cubic-bezier(0.8,1,1,0.8)";
      document.getElementById("navbar").style.backgroundColor =
        "transparent";
      document.getElementById("navbar").style.boxShadow = "none";
      document.querySelectorAll(".nav-item").forEach(function (elem) {
        elem.style.padding = "0.4rem";
        elem.style.transition = "all 0.3s cubic-bezier(0.8,1,1,0.8)";
      });
    }
  };

  useEffect(() => {

    document.querySelectorAll('.nav-link').forEach((l) => {
      l.addEventListener("click", function () {
        document.getElementById('navbarSupportedContent').classList.remove("show");
      })
    })
    new WOW().init();
    window.history.scrollRestoration = "manual";

    window.addEventListener("scroll", ScrollingFunction);
    return () => {
      window.removeEventListener("scroll", ScrollingFunction);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div
        data-bs-target='#navbar'
        className='scrollspy-example'
        tabIndex={0}
      >
        <Home />
        <About />
        <Skills />
        <Projects />
        <Contacts />
      </div>
    </>
  );
}

export default App;
